// extracted by mini-css-extract-plugin
export default {"container":"styles__container___sdzqK","icon":"styles__icon___FmS7a","title":"styles__title___fI0U4","description":"styles__description___HnByt","action":"styles__action___6q8Wj"};